import {
  createMappingUtilsForApp,
  config,
  parsers,
} from "@timeedit/registration-shared";
import logger from "./logger";

/**
 * Function that creates an instance of the mapping utils for an organization.
 * @param organizationId - the id of the organization to create the mapping for
 * @returns an instance of the mapping utils for the organization
 */
export const createMappingInstance = createMappingUtilsForApp({
  config,
  parsers,
  logger,
});
